import { generateMetricKey, generateMetricRatioKey } from '@intelligence/v3/utils/metric';
import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';
import { DATASOURCE_KEY_MAP, SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';
import { RenderType } from '@intelligence/pages/_config/topchartsInterface';

export const companyFilterParams = {
  entity_type: 'mobile',
  source: 'cross_app',
  metric: 'cross_affinity',
  region_type: 'market',
  regions: ['us'],
  granularity: 'monthly',
  start_date: '1970-01-01',
  end_date: '2024-01-10',
  data_sources: ['cross_app'],
  page_size: 500,
  search_name: '',
  page: 1,
  source_metric: {
    cross_app: ['cross_affinity', 'cross_app_usage'],
  },
};

export const overlapAnalysisTalbeHeaderList = [
  {
    text: `dbi_metric_mau`,
    value: SENSORTOWER_METRIC_KEY_MAP.ACTIVE_USERS,
    renderType: RenderType.VALUE_AND_RATIO,
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    width: 220,
    info: 'dbi_overlapanylistis_mau_tabletip',
  },
  {
    text: `dbi_metric_mobile_cross_usage`,
    value: SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE,
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    width: 260,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapanylistis_crossusage_tabletip',
  },
  {
    text: `dbi_metric_mobile_cross_affinity`,
    value: SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY,
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    width: 260,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapanylistis_crossaffinity_tabletip',
  },
];

// SteamGames榜单宽表指标
export const overlapAnalysisSteamTalbeHeaderList = [
  {
    text: `dbi_metric_source_steam_pcu`,
    value: 'source_steam__pcu',
    renderType: RenderType.VALUE_AND_RATIO,
    dataSource: 'source_steam',
    width: 220,
    info: 'dbi_info_source_steam_pcu',
  },
  {
    text: `dbi_overlapsteam_pp_overlap_affinity`,
    value: 'p&p overlap affinity',
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: 'newzoo',
    width: 360,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapsteam_pp_overlap_affinity_info',
    info_extra: 'dbi_metric_data_of_generated_by',
    isNoMore: true,
  },
  {
    text: `dbi_overlapsteam_pw_overlap_affinity`,
    value: 'p&w overlap affinity',
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: 'newzoo',
    width: 360,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapsteam_pw_overlap_affinity_info',
    info_extra: 'dbi_metric_data_of_generated_by',
    isNoMore: true,
  },
  {
    text: `dbi_overlapsteam_wp_overlap_affinity`,
    value: 'w&p overlap affinity',
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: 'newzoo',
    width: 360,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapsteam_wp_overlap_affinity_info',
    info_extra: 'dbi_metric_data_of_generated_by',
    isNoMore: true,
  },
  {
    text: `dbi_overlapsteam_ww_overlap_affinity`,
    value: 'w&w overlap affinity',
    renderType: RenderType.TABLE_SHOW_IMAGE,
    dataSource: 'newzoo',
    width: 360,
    isNoDropdown: true,
    align: 'left',
    info: 'dbi_overlapsteam_ww_overlap_affinity_info',
    info_extra: 'dbi_metric_data_of_generated_by',
    isNoMore: true,
  },
];

// overlapSteam详情页宽表指标 (4-segment 列配置)
export const overlapSteamTalbeHeaderList = {
  played_play: [
    {
      text: `dbi_overlapsteam_overlap_affinity`,
      value: 'p&p overlap affinity',
      renderType: RenderType.VALUE_ONLY,
      width: 220,
      info: 'dbi_overlapsteam_overlap_affinity_info',
      unitText: 'x',
    },
    {
      text: `dbi_overlapsteam_played_play_percent`,
      value: 'played & play',
      renderType: RenderType.GROWTH_ONLY,
      width: 220,
      info: 'dbi_overlapsteam_played_play_percent_info',
    },
    {
      text: `dbi_overlapsteam_average_playtime`,
      value: 'avg_playtime',
      renderType: RenderType.VALUE_ONLY_NO_BMK_UNIT,
      width: 220,
      info: 'dbi_overlapsteam_played_average_playtime_info',
      unitText: 'h',
    },
  ],
  played_wishlist: [
    {
      text: `dbi_overlapsteam_overlap_affinity_pw`,
      value: 'p&w overlap affinity',
      renderType: RenderType.VALUE_ONLY,
      width: 240,
      info: 'dbi_overlapsteam_overlap_affinity_info_pw',
      unitText: 'x',
    },
    {
      text: `dbi_overlapsteam_played_wishlist_percent`,
      value: 'played & wishlist',
      renderType: RenderType.GROWTH_ONLY,
      width: 260,
      info: 'dbi_overlapsteam_played_wishlist_percent_info',
    },
  ],
  wishlisted_play: [
    {
      text: `dbi_overlapsteam_pw_overlap_affinity_detail`,
      value: 'w&p overlap affinity',
      renderType: RenderType.VALUE_ONLY,
      width: 250,
      info: 'dbi_overlapsteam_pw_overlap_affinity_detail_info',
      unitText: 'x',
    },
    {
      text: `dbi_overlapsteam_wishlisted_play_percent`,
      value: 'wishlisted & play',
      renderType: RenderType.GROWTH_ONLY,
      width: 280,
      info: 'dbi_overlapsteam_wishlisted_play_percent_info',
    },
    {
      text: `dbi_overlapsteam_average_playtime`,
      value: 'avg_playtime',
      renderType: RenderType.VALUE_ONLY_NO_BMK_UNIT,
      width: 220,
      info: 'dbi_overlapsteam_wishlist_average_playtime_info',
      unitText: 'h',
    },
  ],
  wishlisted_wishlist: [
    {
      text: `dbi_overlapsteam_ww_overlap_affinity_detail`,
      value: 'w&w overlap affinity',
      renderType: RenderType.VALUE_ONLY,
      width: 260,
      info: 'dbi_overlapsteam_ww_overlap_affinity_detail_info',
      unitText: 'x',
    },
    {
      text: `dbi_overlapsteam_wishlisted_wishlist_percent`,
      value: 'wishlisted & wishlist',
      renderType: RenderType.GROWTH_ONLY,
      width: 300,
      info: 'dbi_overlapsteam_wishlisted_wishlist_percent_info',
    },
  ],
} as any;

const CROSS_APP_METRIC_KEYS = [
  DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
  DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
];
export const getOverlapMetricValueOfCvm = (cvm: any, metricKey: string, dataSourceKey: string) => {
  if (!cvm || !metricKey || !dataSourceKey) {
    return undefined;
  }

  const dbiMetricKey = generateMetricKey({ dataSource: dataSourceKey, metric: metricKey });

  if (CROSS_APP_METRIC_KEYS.includes(dbiMetricKey)) {
    const crossGames = cvm?.[dbiMetricKey] || [];
    return crossGames.map((crossGame: any) => {
      return {
        id: crossGame?.target_game_id || '',
        name: crossGame?.game_name || '',
        cover: crossGame?.cover || '',
      };
    });
  }

  return {
    value: cvm?.[dbiMetricKey],
    growth_ratio: cvm?.[generateMetricRatioKey(dbiMetricKey)],
  };
};

export const getOverlapSteamGamesMetricValueOfCvm = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return undefined;
  }
  try {
    // const metric =  Array.isArray(metrics) && metrics?.find((item: any) => item.metric === metricKey);
    // 处理 PCU 指标（包括 source_steam__pcu、pcu 和 gamalytic__pcu）
    if (['source_steam__pcu', 'gamalytic__pcu', 'pcu'].includes(metricKey)) {
      const metric = cvm?.metric_list?.pcu_metric;
      return {
        value: metric?.value,
        growth_ratio: metric?.dod ? metric?.dod : metric?.growth_ratio,
      };
    }

    // Steam Games-宽表商店指标从overlap_metrics字段找，并按Rank排序
    const overLapMetric = cvm?.metric_list?.overlap_metrics;
    if (Array.isArray(overLapMetric) && overLapMetric?.length > 0) {
      const metricList: any = [];
      overLapMetric?.forEach((item: any) => {
        if (item.metric === metricKey) {
          metricList.push(item);
        }
      });
      metricList?.sort((a: any, b: any) => a.rank - b.rank);
      return metricList;
    }

    // 若metric_list为数组，从中找出匹配metirc的对象
    if (Array.isArray(cvm?.metric_list) && cvm?.metric_list?.length > 0) {
      const metricObjTemp = cvm?.metric_list?.find((item: any) => item.metric == metricKey) || {};
      return metricObjTemp;
    }

    return cvm?.metric_list?.[metricKey];
  } catch (err) {
    console.log(err, cvm);
    return;
  }
};

/**
 * 获取当前游戏列表中所有Cross App Usage、Cross Affinity游戏的id列表
 * @param games 游戏列表
 * @return 游戏id列表
 */
export const getCrossGameIds = (games?: IMetricDataGame[] | null): string[] => {
  if (!Array.isArray(games) || games.length === 0) {
    return [];
  }

  const ids = new Set<string>();

  const appendCrossGameIds = (crossGames?: any[] | null) => {
    if (!Array.isArray(crossGames) || crossGames.length === 0) {
      return;
    }

    for (const crossGame of crossGames) {
      const crossGameId = crossGame?.target_game_id || '';
      if (!!crossGameId) {
        ids.add(crossGameId);
      }
    }
  };

  for (const game of games) {
    const crossAppUsageGames = game?.[DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE] || [];
    appendCrossGameIds(crossAppUsageGames);

    const crossAffinityGames = game?.[DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY] || [];
    appendCrossGameIds(crossAffinityGames);
  }

  return Array.from(ids);
};
